/**
 * Wat er gebeurt wanneer je in een gedockt info-paneel op een markdown-link
 * naar een andere doc klikt:
 *  - `same-panel`: vervangt de inhoud van hetzelfde paneel (met terug-knoppen
 *    en een per-paneel history-stack — meerdere niveaus terug);
 *  - `new-panel`: opent de doelinhoud in een apart gedockt paneel ernaast.
 *
 * Instelbaar via het settings-paneel; default `same-panel`.
 */
export type HdDocLinkOpenBehavior = 'same-panel' | 'new-panel';

export const HD_DOC_LINK_OPEN_BEHAVIOR_DEFAULT: HdDocLinkOpenBehavior = 'same-panel';

export interface HdDocLinkOpenBehaviorOption {
  readonly id: HdDocLinkOpenBehavior;
  readonly labelKey: string;
}

/**
 * Dropdown-opties voor het settings-paneel. `id`/`labelKey` matcht de
 * `resolveOptions`-helper van {@link HdChartSettingsPanelComponent}.
 */
export const HD_DOC_LINK_OPEN_BEHAVIOR_OPTIONS: readonly HdDocLinkOpenBehaviorOption[] = [
  { id: 'same-panel', labelKey: 'humanDesign.chart.options.docLinkOpenBehavior.samePanel' },
  { id: 'new-panel', labelKey: 'humanDesign.chart.options.docLinkOpenBehavior.newPanel' },
];
